import React from 'react';

import { getFullNameWithInitial } from 'Utilities/formatHelper';

import chevronImg from 'Images/chevron-right.svg';

import styles from './List.module.scss';

type Props = {
  className?: string;
  id?: string;
  itemAction: (id: string) => void;
  items: any[];
  title?: string;
};

const List: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  id = 'list',
  itemAction,
  items,
  title,
}) => {
  return (
    <div className={className}>
      <div id={id} className="d-flex flex-column w-100">
        {title && (
          <span id={`${id}-title`} className={`text-black font-weight-bold ${styles.title}`}>
            {title}
          </span>
        )}
        {items.map((item, index) => {
          const name = item.name || getFullNameWithInitial(item);

          return (
            <div
              id={`${id}-item-${item.id || index}`}
              key={item.id || index}
              className={`d-flex justify-content-between align-items-center line-height-xxl ${styles.item}`}
              onClick={() => itemAction(item.id || index)}
            >
              <span id="item-name">{name}</span>
              <img className="rtlFlip" src={chevronImg} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default List;
